/* eslint-disable react/forbid-prop-types */
import React, { Component } from "react";
import { DropdownSkeleton, ComboBox } from "carbon-components-react";
import PropTypes from "prop-types";
import AuditRepository from "../../../helpers/api/AuditRepository";
import MeRepository from "../../../helpers/api/MeRepository";

export default class OnBehalfProjectComboBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			items: [],
		};
		this.onChange = this.onChange.bind(this);
		this.repository = new AuditRepository();
	}

	async componentDidMount() {
		if (!this.props.company) return;
		this.setState({ loading: true });
		const items = await this.getItems();
		this.setState({ items, loading: false });
	}

	onChange = (selectedItem) => {
		const item = selectedItem ? selectedItem.selectedItem : null;
		this.props.onChange(item);
	};

	getItems = async () => {
		let items = [];

		try {
			//RITM0544059 quando chiamo il componente dalla tabella gli passo "ALL" per avere tutti i project a me abilitati.
			items = await MeRepository.getProjects(this.props.company === "ALL" ? null : this.props.company);
		} catch (error) {
			console.error(error);
			this.props.onError(error);
		}
		return items;
	};

	render() {
		return this.state.loading ? (
			<DropdownSkeleton />
		) : (
			<ComboBox
				id="comboBoxBehalfProject"
				invalid={this.props.invalid}
				invalidText={this.props.invalidText}
				disabled={this.state.items < 1 || this.props.disabled}
				placeholder="Choose a Project"
				items={this.state.items}
				onChange={this.onChange}
				shouldFilterItem={({ item, inputValue }) => item.name.toLowerCase().includes(inputValue.toLowerCase()) || item.code.toLowerCase().includes(inputValue.toLowerCase())}
				itemToString={(item) => (item ? item && item.name : "")}
				selectedItem={this.props.selectedItem}
			/>
		);
	}
}

OnBehalfProjectComboBox.propTypes = {
	company: PropTypes.string,
	invalid: PropTypes.bool,
	invalidText: PropTypes.string,
	onChange: PropTypes.func.isRequired,
	onError: PropTypes.func.isRequired,
	selectedItem: PropTypes.object,
	disabled: PropTypes.bool,
};
OnBehalfProjectComboBox.defaultProps = {
	company: null,
	invalid: false,
	invalidText: "",
	selectedItem: null,
	disabled: true,
};
